"use client";
import Link from "next/link";
import { ChevronLeft } from "lucide-react";
import SwiperComponent from "@/components/ui/swiper-component";
import MediaComponent from "@core/helpers/client/components/image";
import Title from "../Title";
import DeviceOnly from "@/components/DeviceOnly";


function ProductCard({ product, storage_prefix_url }) {

    return (
        // سوایپر در حالت گرید فقط `spaceBetween` را به فاصله‌ی ردیف‌ها می‌دهد،
        // ولی فاصله‌ی دیده‌شده‌ی ستون‌ها همان `spaceBetween` به‌علاوه‌ی پدینگ افقی
        // دو کارت است. پس پدینگ عمودی هم قرینه‌ی پدینگ افقی گذاشته می‌شود تا
        // ردیف‌ها (مخصوصا در موبایل) به هم چسبیده دیده نشوند.
        <div className="px-2 py-2">
            <Link
                href={product?.seo?.full_url || "#"}
                className="block h-[100px] lg:h-[150px]" >

                <div className="relative h-full gap-2">

                    {/* Gray box */}
                    <div
                        className=" absolute inset-x-0 top-5 h-[70px] lg:top-[34px] lg:h-[82px]" >
                        <div className="h-full bg-jmt-neutral-100 rounded-md flex items-center pr-[100px] lg:pr-[150px] pl-4"
                        >
                            <span className="text-xs lg:text-[13px] text-jmt-neutral-800 line-clamp-2 pr-2">
                                {product?.title}
                            </span>
                        </div>
                    </div>

                    {/* Image */}
                    <div
                        className="absolute right-0 top-0 aspect-square h-[100px] lg:h-[150px]">
                        <MediaComponent
                            src={product?.media?.url || ""}
                            alt={product?.media?.alt || product?.media?.title}
                            width={100}
                            height={100}
                            style={{ width: "100%", height: "100%" }}
                            storage_prefix_url={storage_prefix_url}
                            image_className="aspect-square h-[100px] lg:h-[150px] object-contain"
                        />
                    </div>
                </div>
            </Link>
        </div>
    );
}

/* Loader */
export default function HomeBestSeller({ fields, collection_data, storage_prefix_url, limit = 10,
}) {
    // کارت‌ها همراه ویجت از کوئری صفحه (getPrefixUrlDetails) می‌آیند؛ fetch کلاینتی نداریم
    const products = collection_data?.products || [];


    return (
        <>
            <DeviceOnly on="mobile">
                <div className="block lg:hidden w-full mx-auto">
                    {/* header */}
                    <div className="flex items-center justify-between px-4 md:px-10 pb-4">
                        <div className="flex items-center gap-1 lg:gap-2">
                            <div
                                className="text-editor-svg"
                                dangerouslySetInnerHTML={{
                                    __html: fields?.icon,
                                }}
                            />

                            <Title
                                type={fields?.title?.type}
                                className="font-bold text-base md:text-xl text-jmt-main"
                            >
                                {fields?.title?.title || ""}
                            </Title>
                        </div>
                        {fields?.link?.url ?
                            <Link
                                href={fields?.link?.url || ""}
                                className="flex items-center text-xs lg:text-sm text-jmt-neutral-800 font-bold gap-1">
                                {fields?.["text-link"]}
                                <ChevronLeft className="w-4.5 h-4.5 lg:w-5 lg:h-5" />
                            </Link> : ""}
                    </div>

                    <SwiperComponent
                        slides={products?.length > 0 ? products.slice(0, limit).map((product, index) => (
                            <ProductCard
                                key={`product-${product.id} product-${index}`}
                                product={product}
                                storage_prefix_url={storage_prefix_url}
                            />)) : []}
                        slidesPerView={1.3}
                        spaceBetween={12}
                        navigation={true}
                        hideNavOnMobile={true}
                        navPosition="side"
                        loop={false}
                        pagination={false}
                        grabCursor={true}
                        swiper_className="bestSellerSwiper px-4! md:px-10!"
                        breakpoints={{
                            500: {
                                slidesPerView: 2,
                                spaceBetween: 12,
                                grid: { rows: 2 },
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 16,
                                grid: { rows: 2 },
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 16,
                                grid: { rows: 2 },
                            },
                            1280: {
                                slidesPerView: 4,
                                spaceBetween: 24,
                                grid: { rows: 2 },
                            },
                        }}
                        grid={{
                            rows: 2,
                            fill: "row",
                        }}
                    />
                </div>
            </DeviceOnly>

            <DeviceOnly on="desktop">
                <div className="hidden lg:block">
                    <div className="container">

                        {/* header */}
                        <div className="flex items-center justify-between px-0 pb-4">
                            <div className="flex items-center gap-1 lg:gap-2">
                                <div
                                    className="text-editor-svg"
                                    dangerouslySetInnerHTML={{
                                        __html: fields?.icon,
                                    }}
                                />

                                <Title
                                    type={fields?.title?.type}
                                    className="font-bold text-base md:text-xl text-jmt-main"
                                >
                                    {fields?.title?.title || ""}
                                </Title>
                            </div>
                            {fields?.link?.url ?
                                <Link
                                    href={fields?.link?.url || ""}
                                    className="flex items-center text-xs lg:text-sm text-jmt-neutral-800 font-bold gap-1">
                                    {fields?.["text-link"]}
                                    <ChevronLeft className="w-4.5 h-4.5 lg:w-5 lg:h-5" />
                                </Link> : ""}                    </div>

                        <SwiperComponent
                            slides={products?.length > 0 ? products.slice(0, limit).map((product, index) => (
                                <ProductCard
                                    key={`product-${product.id} product-${index}`}
                                    product={product}
                                    storage_prefix_url={storage_prefix_url}
                                />)) : []}
                            slidesPerView={1.3}
                            spaceBetween={12}
                            navigation={true}
                            hideNavOnMobile={true}
                            navPosition="side"
                            loop={false}
                            pagination={false}
                            grabCursor={true}
                            swiper_className="bestSellerSwiper"
                            breakpoints={{
                                500: {
                                    slidesPerView: 2,
                                    spaceBetween: 12,
                                    grid: { rows: 2 },
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 16,
                                    grid: { rows: 2 },
                                },
                                1024: {
                                    slidesPerView: 3,
                                    spaceBetween: 16,
                                    grid: { rows: 2 },
                                },
                                1280: {
                                    slidesPerView: 4,
                                    spaceBetween: 24,
                                    grid: { rows: 2 },
                                },
                            }}
                            grid={{
                                rows: 2,
                                fill: "row",
                            }}
                        />
                    </div>
                </div>
            </DeviceOnly>
        </>
    );
}
